module.exports = __webpack_public_path__ + "static/media/icon-pdf.57044fea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-pdf.svg
// module id = 1569
// module chunks = 0